import { render, staticRenderFns } from "./description_service_modal.vue?vue&type=template&id=da8af4c8"
import script from "./description_service_modal.vue?vue&type=script&lang=js"
export * from "./description_service_modal.vue?vue&type=script&lang=js"
import style0 from "./description_service_modal.vue?vue&type=style&index=0&id=da8af4c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports